import React from 'react'

type MapTeamPositionContextValue = Record<string, google.maps.LatLng | google.maps.LatLngLiteral>

export const MapTeamPositionContext = React.createContext<MapTeamPositionContextValue>({})

export interface MapTeamPositionProviderProps {
  positions?: MapTeamPositionContextValue
  children: React.ReactNode
}

export const MapTeamPositionProvider: React.FC<MapTeamPositionProviderProps> = ({ positions = {}, children }) => (
  <MapTeamPositionContext.Provider value={positions}>{children}</MapTeamPositionContext.Provider>
)
